export default __webpack_public_path__ + "static/media/grandmaAndLady.6daab529.jpg";